import "./App.css";
import VideoPlayer from "./components/left/videoplayer";
import VideoUpload from "./components/VideoUpload/VideoUpload";
import Navbar from "./components/Navbar/Navbar";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import Settings from "./components/Settings/Settings";
import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/Home/Home";
import Profile from "./components/Profile/Profile";
import Images from "./components/Images/Images";
import ImageUpload from "./components/ImageUpload/ImageUpload";

function App() {
  const [video, setVideo] = useState("");
  const setvideo = (video) => {
    console.log("setvideo===============", video);
    setVideo(video);
  };

  const isAuthenticated = () => {
    // return true;
    return !!localStorage.getItem("token");
  };

  const PrivateRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/login" />;
  };

  return (
    <div className="App">
      <Navbar />
      <div className="content">
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Home setvideo={setvideo} />
              </PrivateRoute>
            }
          />
          {/* <Route path="/player" element={<VideoPlayer videoid={videoid} />} /> */}
          <Route
            path="/player"
            element={
              <PrivateRoute>
                <div className="container">
                  <div className="left-section">
                    <VideoPlayer videoDetail={video} />
                  </div>
                  <div className="right-section">
                    <Home setvideo={setvideo} />
                  </div>
                </div>
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile setvideo={setvideo} />
              </PrivateRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <PrivateRoute>
                <VideoUpload />
              </PrivateRoute>
            }
          />
          <Route
            path="/library"
            element={
              <PrivateRoute>
                {/* <h1>This Page will come soon</h1> */}
              </PrivateRoute>
            }
          />
          <Route
            path="/images"
            element={
              <PrivateRoute>
                <Images />
              </PrivateRoute>
            }
          />
          <Route
            path="/image-upload"
            element={
              <PrivateRoute>
                <ImageUpload />
              </PrivateRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
